module.exports = __webpack_public_path__ + "img/fig12.25eec8ed.jpg";